[
  {
    "id": 1,
    "heading": "Patient Satisfaction",
    "text": "Syndromic testing can enhance patient outcomes by guiding more precise and timely therapies, lowering hospital admissions, and reducing the misuse of antimicrobials.",
    "reference": [ 10, 11 ]
  },
  {
    "id": 2,
    "heading": "Faster Triage",
    "text": "PCR testing has been shown to <strong>significantly enhance patient triage efficiency</strong>.",
    "reference": 8
  },
  {
    "id": 3,
    "heading": "Improved Workflow",
    "text": "Streamlined and faster sample-to-answer workflows with Minimal hands-on time and sample preparation.",
    "reference": [ 9, 12, 13 ]
  },
  {
    "id": 4,
    "heading": "Reduce Cost",
    "text": "Syndromic testing leads to more accurate diagnoses, improved patient outcomes, and potentially reduced long-term costs.",
    "reference": 9
  }
]
